import React, { useState } from "react";
import OTPInput from "react-otp-input";
import ResendMobileOTP from "./ResendOtp/ResendMobileOtp";
import { Spinner } from "reactstrap";
import { CustomSnackbar } from "../CustomSnackbar";
import { apiErrorHandler } from "../common";
import { verifyMobileOtp } from "../../api/customer";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux"; // Added for auto-login
import { useNavigate } from "react-router-dom"; // Added for redirect
import { login } from "../../actions/customer"; // Verify this path matches your project structure

const VerifyMobile = ({ formData, onVerifyMobileSuccess }) => {
  const [otp, setOtp] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleVerifyMobile = async () => {
    console.log("DEBUG - Starting Verification", {
      email: formData?.email,
      phone: formData?.phoneNumber,
      role: formData?.role, // Should be 'employer' or 'candidate'
    });

    if (!otp || otp.length < 6) {
      CustomSnackbar.error("Please enter a valid 6-digit OTP!");
      return;
    }

    if (isLoading) return;

    setIsLoading(true);
    try {
      const payload = {
        phoneNumber: formData?.phoneNumber,
        otp: otp,
      };

      const response = await verifyMobileOtp(payload);
      console.log("DEBUG - API Response:", response);

      // Check for success (token or 200 status)
      if (
        response?.data?.token ||
        response?.status === 200 ||
        response?.data?.success
      ) {


        CustomSnackbar.success("Mobile Verified Successfully!");

        const loginPayload = {
          login_method: "email",
          email: formData?.email,
          password: formData?.password,
        };

        console.log("DEBUG - Attempting Auto-Login for role:", formData?.role);

        dispatch(login(loginPayload))
          .then((res) => {
            console.log("DEBUG - Login Success. Directing to panel...");

            // --- ROLE BASED REDIRECT LOGIC ---
            setTimeout(() => {
              navigate("/thank-you", {
                state: {
                  role: formData?.role || "candidate", // Passes "employer" or "candidate"
                  name: formData?.first_name || formData?.name || "", // Optional: Pass user's name for personalized welcome
                },
              });
            }, 100);

            if (onVerifyMobileSuccess) {
              onVerifyMobileSuccess();
            }
          })
          .catch((loginErr) => {
            console.error("DEBUG ERROR - Login Failed:", loginErr);
            CustomSnackbar.error(
              "Verification successful, but login failed. Please sign in.",
            );
            navigate("/signin");
          });
      } else {
        CustomSnackbar.error("Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("DEBUG ERROR - API Exception:", error);
      apiErrorHandler(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-100 verification-container">
      <div className="verification-card">
        <div className="text-center mb-4">
          <h4 className="verification-title">Verify Mobile Number</h4>
          <p className="verification-subtitle">
            An OTP has been sent to your Whatsapp number{" "}
            <b>{formData?.phoneNumber}</b>. Please verify your mobile number to
            continue.
          </p>
        </div>

        <div className="otp-container">
          <OTPInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderSeparator={<span style={{ margin: 4 }}>-</span>}
            containerStyle={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "nowrap",
              gap: "3px",
              marginBottom: "15px",
              padding: "0 5px",
              maxWidth: "100%",
            }}
            inputType="number"
            renderInput={(props) => (
              <input
                {...props}
                className={`otp-input`}
                style={{ flexShrink: 0 }}
              />
            )}
          />
        </div>

        <div className="resend-otp-container">
          <ResendMobileOTP phoneNumber={formData?.phoneNumber} maxTime={60} />
        </div>

        <div className="text-center mt-4">
          {isLoading ? (
            <button className="verify-btn w-50 disabled" type="button" disabled>
              <Spinner size="sm" className="me-2" />
              Verifying...
            </button>
          ) : (
            <button
              className="verify-btn w-50"
              type="button"
              onClick={handleVerifyMobile}
            >
              Verify Mobile
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

VerifyMobile.propTypes = {
  formData: PropTypes.object,
  onVerifyMobileSuccess: PropTypes.func,
};

export default VerifyMobile;
